import { AppState } from 'src/app/core/core.state'
import { ResourceEffects } from 'src/app/shared/resource-effects'

import { Injectable } from '@angular/core'
import { Actions } from '@ngrx/effects'
import { Store } from '@ngrx/store'

import { Competition } from './competition'
import { competitionActions } from './competition.actions'
import * as fromCompetition from './competition.reducer'
import { CompetitionService } from './competition.service'

@Injectable()
export class CompetitionEffects extends ResourceEffects<Competition> {
  constructor(
    public actions$: Actions,
    public store: Store<AppState>,
    public competitionService: CompetitionService
  ) {
    super(
      fromCompetition.FEATURE_NAME,
      competitionService,
      competitionActions,
      actions$
    )
  }
}
